import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { nav, logoSymbol } from "@/data";
import { useBooking } from "@/context/BookingContext";

export default function Header() {
  const { menuOpen, setMenuOpen } = useBooking();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const renderLink = (item) => (
    <Link key={item.label} to={item.to} onClick={() => setMenuOpen(false)} data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
      {item.label}
    </Link>
  );

  return (
    <header className={`site-header ${scrolled ? "is-scrolled" : ""} ${menuOpen ? "nav-open" : ""}`} data-testid="site-header">
      <div className="header-inner">
        <nav className="site-nav site-nav-left" data-testid="main-navigation">
          {nav.slice(0, 3).map(renderLink)}
        </nav>
        <Link to="/" className="header-logo" data-testid="brand-logo">
          <img src={logoSymbol} alt="The Vanda" />
        </Link>
        <nav className="site-nav site-nav-right" data-testid="main-navigation-right">
          {nav.slice(3).map(renderLink)}
        </nav>
        <nav className="site-nav site-nav-mobile" data-testid="main-navigation-mobile">
          {nav.map(renderLink)}
        </nav>
        <button className="mobile-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-expanded={menuOpen} aria-label="Toggle menu" data-testid="mobile-menu-button">
          {menuOpen ? <X /> : <Menu />}
        </button>
      </div>
    </header>
  );
}
